import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WeatherSnowIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M11.1 12.9V14.3772L7.6136 17.8636L8.8864 19.1364L11.1 16.9228V20H12.9V16.9228L15.1136 19.1364L16.3864 17.8636L12.9 14.3772V12.9H14.3772L17.8636 16.3864L19.1364 15.1136L16.9228 12.9H20V11.1H16.9228L19.1364 8.8864L17.8636 7.6136L14.3772 11.1H12.9V9.62282L16.3864 6.1364L15.1136 4.8636L12.9 7.07723V4H11.1V7.07718L8.8864 4.8636L7.6136 6.1364L11.1 9.62277V11.1H9.62279L6.1364 7.6136L4.8636 8.8864L7.0772 11.1H4V12.9H7.07721L4.8636 15.1136L6.1364 16.3864L9.6228 12.9H11.1Z"
      />
    </SvgIcon>
  );
});
